import pickOne from 'pickoneitem';

/**
 * Test if a variable is iterable
 * @param  {*}  obj
 * @return {Boolean}
 */
function isIterable(obj) {
  if (obj == null) return false;

  return typeof obj[Symbol.iterator] === 'function';
}

const selectors = {
  row: '.row',
  accordionToggle: '.accordion-toggle',
  active: '.active',
  activeClassName: 'active',
};

let accordions = [];
let toggles = [];

function openAccordionItemFromHash() {
  const hash = location.hash;

  if (!hash) return;

  const row = document.querySelector(hash);

  if (row) {
    const button = row.querySelector(selectors.accordionToggle);

    if (!button) return;

    button.click();
  }
}

const init = function () {
  const accordionElements = document.querySelectorAll('[data-accordion]');
  let accordionGroup;

  if (isIterable(accordionElements)) {
    accordionGroup = Array.from(accordionElements);
  } else if (
    accordionElements instanceof Element ||
    accordionElements instanceof HTMLDocument
  ) {
    accordionGroup = [accordionElements];
  }

  if (!accordionGroup) return false;

  accordionGroup.forEach((accordion) => {
    const accordionPicker = pickOne();
    const accordionRows = accordion.querySelectorAll(selectors.row);

    accordionPicker.init({
      className: 'active',
      group: accordionRows,
    });

    accordionRows.forEach((row) => {
      row.addEventListener('click', (event) => {
        const accordionRow = event.currentTarget.closest(selectors.row);

        if (accordionRow.classList.contains(selectors.activeClassName)) {
          accordionPicker.clear();
        } else {
          accordionPicker.pick(accordionRow);
        }
      });
    });
  });

  openAccordionItemFromHash();

  return this;
};

const accordionController = {
  toggles,
  accordions,
  init,
};

export default accordionController;
